<div class="clearfix coreclient-header" id="header">
  <div class="fl">
    <div class="logo" [routerLink]="['/home']">
      <div class="flex h-[64px] cursor-pointer items-center">
        @if (otherLogo) {
          <img [src]="otherLogo" class="h-[56px]" alt="" />
        } @else {
          @if (saasUserInfo?.alias_logo) {
            <img [src]="saasUserInfo?.alias_logo" class="h-[56px]" alt="" />
          } @else {
            <img src="assets/images/logo_v2.png" class="h-[32px]" alt="" />
          }
        }
      </div>
    </div>
    <div class="no-user-select" layout>
      <ul class="no-user-select" nz-menu nzTheme="light" nzMode="horizontal">
        <li nz-menu-item nzMatchRouter>
          <a [routerLink]="['/home']">首页</a>
        </li>
        <li nz-menu-item nzMatchRouter>
          <a [routerLink]="['/promotion/unify']">推广</a>
        </li>
        <!--          <li nz-submenu nzTitle="数据报表">-->
        <!--            <ul>-->
        <!--              <li nz-menu-item nzMatchRouter>-->
        <!--                <a [routerLink]="['/advanced-report']">高级报表</a>-->
        <!--              </li>-->
        <!--            </ul>-->
        <!--          </li>-->
        <!-- <li nz-menu-item nzMatchRouter>
          <a [routerLink]="['/report']">云报表</a>
        </li> -->
        <li
          nz-menu-item
          nzMatchRouter
          nz-popover
          #toolsPopover="nzPopover"
          [nzPopoverContent]="toolsContent"
          [nzPopoverPlacement]="['bottomLeft']"
          nzPopoverOverlayClassName="tools-popover"
        >
          <div class="avatar">
            <span>工具</span>
            <nz-icon
              nzType="caret-down"
              nzTheme="outline"
              class="down ml-[2px] text-gray-500"
            />
          </div>
          <ng-template #toolsContent>
            <div class="layout-header">
              @for (item of HeaderTools; track item) {
                <div class="pb-3">
                  <div class="f17 bold mb-2">{{ item.label }}</div>
                  <div class="tool">
                    @for (tool of item.tools; track tool) {
                      <div
                        layout
                        class="tool-item"
                        (click)="handleEnterTool(tool); toolsPopover.hide()"
                      >
                        <img [src]="tool.icon" class="logo" layout-align="start center" />
                        <div layout-align="end center">
                          <div class="f16 bold">{{ tool.title }}</div>
                          <div class="f13 gray mt5">{{ tool.describe }}</div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          </ng-template>
        </li>
      </ul>
    </div>
  </div>
  <div class="fr flex items-center">
    <!-- <a routerLink="/tools/warning" class="mr-2 text-[#E36F54]">预警设置</a> -->
    <div routerLink="/tools/warning" class="mr-2">
      <button nz-button nzType="default" nzSize="small" style="border-color: #fff1eb">
        <span [innerHTML]="warningSvg" style="vertical-align: text-top"></span
        ><span class="ml-[2px] text-sm text-[#E36F54]">预警设置</span>
      </button>
    </div>
    <div
      class="real-name"
      nz-popover
      [nzPopoverContent]="userContent"
      [nzPopoverPlacement]="['bottomRight']"
      nzPopoverOverlayClassName="user-popover"
    >
      <nz-avatar
        [nzSize]="32"
        nzIcon="user"
        nzSrc="https://static-cdn.linkworld.cn/xiaohong/avatar.png"
      ></nz-avatar>
      <span class="gray ml10 name text-sm">{{ userInfo?.realname }}</span>
    </div>
    <ng-template #userContent>
      <div class="pt10 pl5 pr5 pb10">
        <a layout layout-align="start center" class="color-9" (click)="signOut()">
          <span class="primary-color">
            <i nz-icon nzType="logout" nzTheme="outline"></i>
          </span>
          <span class="ml10">退出账号</span>
        </a>
      </div>
    </ng-template>
  </div>
</div>

<!-- 批量编辑创意对话框 -->
<app-batch-edit-creative
  [isVisible]="uploadDialogService.isEditCreativeVisible()"
  (isVisibleChange)="uploadDialogService.closeEditCreativeDialog()"
></app-batch-edit-creative>

<!-- 批量添加创意对话框 -->
<app-batch-upload-creative
  [isVisible]="uploadDialogService.isUploadCreativeVisible()"
  (isVisibleChange)="uploadDialogService.closeUploadCreativeDialog()"
></app-batch-upload-creative>

<!-- 批量上传监测链接对话框 -->
<app-batch-upload-monitor
  [isVisible]="uploadDialogService.isUploadMonitorVisible()"
  (isVisibleChange)="uploadDialogService.closeUploadMonitorDialog()"
></app-batch-upload-monitor>

<!-- 批量上传关键词对话框 -->
<app-batch-upload-keyword
  [isVisible]="uploadDialogService.isUploadKeywordVisible()"
  (isVisibleChange)="uploadDialogService.closeUploadKeywordDialog()"
></app-batch-upload-keyword>

<!-- 批量上传计划对话框 -->
<app-batch-upload-campaign
  [isVisible]="uploadDialogService.isUploadCampaignVisible()"
  (isVisibleChange)="uploadDialogService.closeUploadCampaignDialog()"
></app-batch-upload-campaign>

<!-- 批量修改计划预算对话框 -->
<app-batch-upload-campaign-budget
  [isVisible]="uploadDialogService.isUploadCampaignBudgetVisible()"
  (isVisibleChange)="uploadDialogService.closeUploadCampaignBudgetDialog()"
></app-batch-upload-campaign-budget>

<!-- 批量修改计划名称对话框 -->
<app-batch-upload-campaign-name
  [isVisible]="uploadDialogService.isUploadCampaignNameVisible()"
  (isVisibleChange)="uploadDialogService.closeUploadCampaignNameDialog()"
></app-batch-upload-campaign-name>

<!-- 批量修改单元出价对话框 -->
<app-batch-upload-unit-bid
  [isVisible]="uploadDialogService.isUploadUnitBidVisible()"
  (isVisibleChange)="uploadDialogService.closeUploadUnitBidDialog()"
></app-batch-upload-unit-bid>

<!-- 批量修改高级定向对话框 -->
<app-batch-upload-unit-target
  [isVisible]="uploadDialogService.isUploadUnitTargetVisible()"
  (isVisibleChange)="uploadDialogService.closeUploadUnitTargetDialog()"
></app-batch-upload-unit-target>

<!-- 批量修改关键词出价对话框 -->
<app-batch-upload-keyword-bid
  [isVisible]="uploadDialogService.isUploadKeywordBidVisible()"
  (isVisibleChange)="uploadDialogService.closeUploadKeywordBidDialog()"
></app-batch-upload-keyword-bid>
